import {
  OrderedRelativeFilterItem,
  RelativeFilterResponseBody,
  ReorderRelativeFiltersRequestBody,
} from '../../../../../types/api/api';

export function buildReorderRelativeFiltersBody(
  orderedPresets: RelativeFilterResponseBody[]
): ReorderRelativeFiltersRequestBody {
  const items: OrderedRelativeFilterItem[] = orderedPresets.map((preset, index) => ({
    id: preset.id,
    position: index + 1,
  }));

  return {items};
}
